/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Pxk_TitleInputs */

const vi_pkl_pxk_title = /** @type {(inputs: Pkl_Pxk_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu xuất`)
};

/**

* @param {Pkl_Pxk_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_pxk_title = /** @type {((inputs?: Pkl_Pxk_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Pxk_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_pxk_title(inputs)
});